import DatatableComponent from "../../helpers/DatatableComponent";
import React from "react";

const CompletionCertificate = ({ setOpen, count, columnsCert, setList }) => {
  return (
    <>
      <DatatableComponent
        onRowClick={(data, { rowIndex }) => {}}
        onAddNew={() => setOpen(1)}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={columnsCert}
        url={`/api/document/list?count=${count}&type=certificate`}
        title={``}
      />
    </>
  );
};

export default CompletionCertificate;
